// src/reducers/hdfcCardUPReducers.js
import {
  GET_ALL_HDFC_CARD_UP_REQUEST,
  GET_ALL_HDFC_CARD_UP_SUCCESS,
  GET_ALL_HDFC_CARD_UP_FAIL,
  CREATE_HDFC_CARD_UP_REQUEST,
  CREATE_HDFC_CARD_UP_SUCCESS,
  CREATE_HDFC_CARD_UP_FAIL,
  UPDATE_HDFC_CARD_UP_REQUEST,
  UPDATE_HDFC_CARD_UP_SUCCESS,
  UPDATE_HDFC_CARD_UP_FAIL,
  DELETE_HDFC_CARD_UP_REQUEST,
  DELETE_HDFC_CARD_UP_SUCCESS,
  DELETE_HDFC_CARD_UP_FAIL,
  BULK_DELETE_HDFC_CARD_UP_REQUEST,
  BULK_DELETE_HDFC_CARD_UP_SUCCESS,
  BULK_DELETE_HDFC_CARD_UP_FAIL,
  IMPORT_HDFC_CARD_UP_REQUEST,
  IMPORT_HDFC_CARD_UP_SUCCESS,
  IMPORT_HDFC_CARD_UP_FAIL,
  EXPORT_HDFC_CARD_UP_REQUEST,
  EXPORT_HDFC_CARD_UP_SUCCESS,
  EXPORT_HDFC_CARD_UP_FAIL,
  GET_HDFC_CARD_UP_DEPARTMENTS_REQUEST,
  GET_HDFC_CARD_UP_DEPARTMENTS_SUCCESS,
  GET_HDFC_CARD_UP_DEPARTMENTS_FAIL,
} from "../constants/hdfcCardUPConstants";

// Get HDFC Card UP Records Reducer
export const getHdfcCardUPRecordsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_HDFC_CARD_UP_REQUEST:
      return { loadingGetHdfcCardUPRecords: true };
    case GET_ALL_HDFC_CARD_UP_SUCCESS:
      return {
        loadingGetHdfcCardUPRecords: false,
        getHdfcCardUPRecordsData: action.payload,
      };
    case GET_ALL_HDFC_CARD_UP_FAIL:
      return {
        loadingGetHdfcCardUPRecords: false,
        errorGetHdfcCardUPRecords: action.payload,
      };
    default:
      return state;
  }
};

// Create HDFC Card UP Reducer
export const createHdfcCardUPReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_HDFC_CARD_UP_REQUEST:
      return { loading: true };
    case CREATE_HDFC_CARD_UP_SUCCESS:
      return { loading: false, success: true, record: action.payload };
    case CREATE_HDFC_CARD_UP_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Update HDFC Card UP Reducer
export const updateHdfcCardUPReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_HDFC_CARD_UP_REQUEST:
      return { loadingUpdateHdfcCardUP: true };
    case UPDATE_HDFC_CARD_UP_SUCCESS:
      return {
        loadingUpdateHdfcCardUP: false,
        updateHdfcCardUPData: action.payload,
      };
    case UPDATE_HDFC_CARD_UP_FAIL:
      return {
        loadingUpdateHdfcCardUP: false,
        errorUpdateHdfcCardUP: action.payload,
      };
    default:
      return state;
  }
};

// Delete HDFC Card UP Reducer
export const deleteHdfcCardUPReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_HDFC_CARD_UP_REQUEST:
      return { loading: true };
    case DELETE_HDFC_CARD_UP_SUCCESS:
      return { loading: false, success: true };
    case DELETE_HDFC_CARD_UP_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Bulk Delete HDFC Card UP Reducer
export const bulkDeleteHdfcCardUPReducer = (state = {}, action) => {
  switch (action.type) {
    case BULK_DELETE_HDFC_CARD_UP_REQUEST:
      return { loadingBulkDeleteHdfcCardUP: true };
    case BULK_DELETE_HDFC_CARD_UP_SUCCESS:
      return {
        loadingBulkDeleteHdfcCardUP: false,
        bulkDeleteHdfcCardUPData: action.payload,
      };
    case BULK_DELETE_HDFC_CARD_UP_FAIL:
      return {
        loadingBulkDeleteHdfcCardUP: false,
        errorBulkDeleteHdfcCardUP: action.payload,
      };
    default:
      return state;
  }
};

// Import HDFC Card UP Reducer
export const importHdfcCardUPReducer = (state = {}, action) => {
  switch (action.type) {
    case IMPORT_HDFC_CARD_UP_REQUEST:
      return { loadingImportHdfcCardUP: true };
    case IMPORT_HDFC_CARD_UP_SUCCESS:
      return {
        loadingImportHdfcCardUP: false,
        importHdfcCardUPData: action.payload,
      };
    case IMPORT_HDFC_CARD_UP_FAIL:
      return {
        loadingImportHdfcCardUP: false,
        errorImportHdfcCardUP: action.payload,
      };
    default:
      return state;
  }
};

// Export HDFC Card UP Reducer
export const exportHdfcCardUPReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_HDFC_CARD_UP_REQUEST:
      return { loadingExportHdfcCardUP: true };
    case EXPORT_HDFC_CARD_UP_SUCCESS:
      return {
        loadingExportHdfcCardUP: false,
        exportHdfcCardUPData: action.payload,
      };
    case EXPORT_HDFC_CARD_UP_FAIL:
      return {
        loadingExportHdfcCardUP: false,
        errorExportHdfcCardUP: action.payload,
      };
    default:
      return state;
  }
};

// Get HDFC Card UP Departments Reducer
export const getHdfcCardUPDepartmentsReducer = (
  state = { departments: [] },
  action,
) => {
  switch (action.type) {
    case GET_HDFC_CARD_UP_DEPARTMENTS_REQUEST:
      return { loading: true, departments: [] };
    case GET_HDFC_CARD_UP_DEPARTMENTS_SUCCESS:
      return { loading: false, departments: action.payload };
    case GET_HDFC_CARD_UP_DEPARTMENTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
